import { State } from './types';

export const verifyEmailStoreSelector = {
  redirectUrl: (state: State): State['redirectUrl'] => state.redirectUrl,
  setRedirectUrl: (state: State): State['setRedirectUrl'] =>
    state.setRedirectUrl,
  clearRedirectUrl: (state: State): State['clearRedirectUrl'] =>
    state.clearRedirectUrl,
};
